<template>
  <StepItem
    format="form"
    title="Verify Company Phone Number"
    subtitle="Code sent!"
    @handle-next-step="handleNextStep"
    can-go-to-prev-step
    :is-ready-for-next-step="companyAccountCreateStore.companyPhoneVerificationCode.length === 6">
    <template v-slot:default>
      <FormVerificationCodeInput
        v-model="companyAccountCreateStore.companyPhoneVerificationCode"
      />
      <p class="mt-8 select-none text-center text-sm text-slate-500">
        Didn't receive a code?
        <b
          @click="requestNewVerificationCode"
          class="cursor-pointer hover:underline"
        >
          <span v-if="countdown !== 0" class="w-92"
          >Request again in {{ countdown }}s</span
          >
          <span v-else>Send new verification code</span>
        </b>
      </p>
    </template>
    <template v-slot:next-step-text>Verify Account</template>
  </StepItem>
</template>

<script setup>
import StepItem from "./StepItem.vue";
import FormVerificationCodeInput from "./FormVerificationCodeInput.vue";
import {onMounted, ref} from "vue";
import {useCompanyAccountCreateStore} from "../stores/CompanyAccountCreateStore.js";

const companyAccountCreateStore = useCompanyAccountCreateStore();
const isReadyForNextStep = ref(false);
const countdown = ref(0);

const emits = defineEmits(["complete"]);

emits("complete");

const handleNextStep = () => {
  isReadyForNextStep.value = companyAccountCreateStore.validateStep3();
  if (isReadyForNextStep.value) {
    emits("complete");
  }
};

const restartTimer = () => {
  if (countdown.value === 0) countdown.value = 59;
  setTimeout(() => {
    countdown.value -= 1;
    if (countdown.value > 0) {
      restartTimer();
    }
  }, 1000);
};

onMounted(() => restartTimer());
</script>
